/**
 * Table Component Tokens
 *
 * Design tokens for PrimeNG 18 DataTable and Paginator components.
 * Maps to Figma DS Table: Header, Body, Footer, Sort, Pagination.
 * Uses semantic token references only; light/dark is resolved by semantic tokens.
 */
export const tableTokens = {
  datatable: {
    header: {
      padding: '0'
    },
    headerCell: {
      background: '{surface.100}',
      selectedBackground: '{surface.100}',
      borderColor: '{orange.300}',
      color: '{surface.1000}',
      selectedColor: '{surface.1000}',
      padding: '1rem',
      gap: '0.5rem',
      focusRing: {
        width: '0',
        style: 'none',
        color: 'transparent',
        offset: '0',
        shadow: 'none'
      }
    },

    columnTitle: {
      fontWeight: '600'
    },

    row: {
      background: '{surface.0}',
      hoverBackground: '{surface.100}',
      selectedBackground: '{highlight.background}',
      color: '{surface.1000}',
      hoverColor: '{surface.1000}',
      selectedColor: '{surface.1000}'
    },

    bodyCell: {
      borderColor: '{surface.300}',
      padding: '1rem'
    },

    footerCell: {
      background: '{surface.100}',
      color: '{surface.1000}',
      padding: '1rem'
    },

    columnFooter: {
      fontWeight: '400'
    },

    footer: {
      background: '{surface.100}',
      color: '{surface.1000}',
      borderWidth: '0',
      padding: '1rem'
    },

    sortIcon: {
      color: '{surface.500}',
      hoverColor: '{primary.color}'
    },

    paginatorBottom: {
      borderColor: 'transparent',
      borderWidth: '0'
    }
  },

  paginator: {
    root: {
      gap: '0.5rem',
      padding: '0',
      background: '{surface.0}',
      color: '{surface.1000}'
    },

    navButton: {
      background: 'transparent',
      hoverBackground: 'transparent',
      selectedBackground: 'transparent',
      color: '{surface.1000}',
      hoverColor: '{primary.color}',
      selectedColor: '{surface.1000}',
      width: '2.5rem',
      height: '2.5rem',
      borderRadius: '1.25rem',
      focusRing: {
        width: '0',
        style: 'none',
        color: 'transparent',
        offset: '0',
        shadow: 'none'
      }
    },

    currentPageReport: {
      color: '{surface.800}'
    }
  }
};

export type TableTokens = typeof tableTokens;
